import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useSetLocationData } from "~/hooks/locationData";

import Button from "~/shared/ui/Fields/Button";
import Default from "~/components/Icons/icon-default";
import Delete from "~/components/Icons/delete-cross";
import s from "./TableRow.less";
import { format } from "date-fns";

interface IProps {
  options: string[];
  type: string;
  btnEdit?: boolean;
  btnView?: boolean;
  btnDel?: boolean;
  btnIndicators?: boolean;
  item;
}

const EditorVersionsTableRow: React.FC<IProps> = ({
  options = [],
  item = {},
  btnEdit = false,
  btnView = false,
  btnDel = false,
  btnIndicators = false,
  type,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const setData = useSetLocationData();
  const withBtns = btnEdit || btnDel || btnView || btnIndicators;
  const isEditorVersion = type === "editor.versions";
  const isDelete =
    isEditorVersion &&
    new Date().toString() < format(new Date(item.dateBegin), "dd.MM.yyyy");

  const goToRatings = () => {
    isEditorVersion &&
      isEditorVersion &&
      (history.push(`${item.id}/`), setData("dateBegin", item.dateBegin));
  };

  const openEditModal = () => {
    setData("openModal", "Edit", "currentId", item.id);
  };
  const openViewModal = () => {
    setData("openChildModal", "View", "currentId", item.id);
  };
  const openDelModal = () => {
    setData("openModal", "Sure", "currentId", item.id);
  };

  return (
    <>
      <tr className={s.row_tr}>
        {options?.map((optionName) => (
          <td key={optionName} data-option_name={optionName}>
            <div>
              <span className={s.cont}>{item[optionName]}</span>
            </div>
          </td>
        ))}

        {withBtns && (
          <td className={s.with_btn}>
            {btnEdit && (
              <div className={s.cont}>
                <Button small txtBtn={t("ui.btn_edit")} onClick={openEditModal}>
                  <Default />
                </Button>
              </div>
            )}

            {btnIndicators && (
              <div className={s.cont}>
                <Button
                  small
                  txtBtn={t("indicators.indicators")}
                  onClick={goToRatings}
                >
                  <Default />
                </Button>
              </div>
            )}

            {btnView && (
              <div
                className={clsx({
                  [s.cont]: true,
                  [s.btn_view]: true,
                  [s.active]: item.countDC === "All",
                })}
              >
                <Button
                  small
                  txtBtn={t("ui.view")}
                  onClick={openViewModal}
                  customClassName={clsx({
                    [s.wide_btn]: true,
                  })}
                >
                  <Default />
                </Button>
              </div>
            )}

            {(btnDel || isDelete) && (
              <div className={s.cont}>
                <Button
                  small
                  txtBtn={t("ui.btn_del")}
                  empty
                  onClick={openDelModal}
                >
                  <Delete />
                </Button>
              </div>
            )}
          </td>
        )}
      </tr>
    </>
  );
};
export default EditorVersionsTableRow;
